import api_metronom from "../metronom/modules/api_metronom";
import ResizeSensor from "css-element-queries/src/ResizeSensor"

export const texts_mixin = {
    data() {
        return {
            metronom: '',

            raw_text: '',
            ready_text: '',
            reading: true,

            /** Исчезающий */
            disappearing_speed: '',
            disappearing_timer: '',
            disappearingStarted: false,


            /** Справочник */
            vovels_rus: ["а", "о", "и", "е", "ё", "э", "ы", "у", "ю", "я"],
            consonants_rus: [],
            punctuation: ['.', ',', '!', '?', '...', ':', '-', '%', '—'],
        }
    },
    props: {},
    watch: {
        'params.mode': 'makeTransform',
        'modeParams': {
            handler() {
                if (this.modeParams.id === 'skip_words') this.skipWords();
                if (this.modeParams && this.modeParams.changes) this.changeLetters();
            },
            deep: 'true'
        }
    },
    computed: {
        printed_text() {
            return this.ready_text;
        },
        modeParams() {
            let mode = this.params.selected_mode;
            if (mode) {
                let id = {
                    id: mode.id
                };
                let params = mode.params;
                params = _.assign(params, id)
                    //console.log('params', params);
                return params;
            }
        },
    },
    methods: {
        makeTransform() {
            console.log('make transform');
            this.$emit('destroy app');
            this.destroyMetronom();
            this.metronom = null;
            this.reading = false;
            this.params.start = true;
            this.params.finish = false;
            switch (this.params.mode) {
                case 'nochange':
                    this.letStartNoChange();
                    break;
                case 'anagrammes':
                    this.makeAnagrammes();
                    break;
                case 'mix_words':
                    this.letMixWords();
                    break;
                case 'words_reverse':
                    this.letReverseWords();
                    break;
                case 'sentence_reverse':
                    this.letReverseSentence();
                    break;
                case 'novowels':
                    this.removeVowels();
                    break;
                case 'skip_words':
                    this.skipWords();
                    break;
                case 'change_letters':
                    this.changeLetters();
                    break;
                case 'skipvowels':
                    this.skipVowels();
                    break;
                case 'striked':
                    this.makeCrossedText();
                    break;
                case 'randcase':
                    this.makeRandomCase();
                    break;
                case 'nospaces':
                    this.makeWithoutSpaces();
                    break;
                case 'rand_spaces':
                    this.makeRandSpaces();
                    break;
                case 'translit':
                    this.translitText();
                    break;
                case 'code':
                    this.codeText();
                    break;
                case 'rotate':
                    this.rotateText();
                    break;
                case 'curtain':
                    this.makeCurtain();
                    break;
                case 'disappearing_text':                    
                    // this.disappearing_text();
                    break;
            }
        },
        texts_test() {
            let text = this.test.text;
        },

        /** ФУНКЦИИ ДЛЯ РАБОТЫ С ТЕКСТАМИ*/
        /* Сырой текст разделяем на массивы по переносам строк */
        rawTextToArray(text) {
            return _.compact(text.split('\n'));
        },
        /* Преобразуем текст в абзацы <p> для вывода */
        textToP(arr, cls = '') {
            let txt = _.map(_.compact(arr), function(e) {
                return `<p class="${cls}">${e}</p>`;
            });
            return txt.join('');
        },
        /* Преобразуем строку в массив слов */
        stringToWordsArray(str) {
            return str.split(' ');
        },
        /* Ищем знак препинания в конце */
        findPuncInEndOfArr(arr) {
            if (this.punctuation.indexOf(_.last(arr)) === -1) return false;
            return true;
        },
        /* Проверяем, гласная ли это */
        isVowel(c) {
            let vowels = this.vovels_rus;
            return vowels.indexOf(c.toLowerCase()) !== -1;
        },
        /* Случайное число */
        randomInteger(min, max) {
            let rand = min + Math.random() * (max + 1 - min);
            return Math.floor(rand);
        },
        /* Получаем текущий размер шрифта */
        getCurrentStyleParam(prop) {
            let el = document.getElementById('text_content');
            let style = window.getComputedStyle(el, null).getPropertyValue(prop);
            let ret = parseFloat(style);
            return ret;
        },

        /** ПРЕОБРАЗОВАНИЯ **/
        /* БЕЗ ИЗМЕНЕНИЙ */
        letStartNoChange() {
            this.makeNormalText('nrm');
            if (!this.metronom) this.metronom = new api_metronom(this.modeParams.metronome_speed.value, this.modeParams.has_metronome.value, false, this);
            $(document).on('change', 'input[type="checkbox"][name="has_metronome"]', (i) => {
                this.metronom.has_metronom = i.target.checked;
            });
            $(document).on('change', 'input[type="range"][name="metronome_speed"]', (i) => {
                this.$emit('change speed');
                this.metronom.bpm = +i.target.value;
            });
        },

        destroyMetronom() {
            $(document).off('change', 'input[type="checkbox"][name="has_metronome"]');
            $(document).off('change', 'input[type="range"][name="metronome_speed"]');
        },

        makeNormalText(cls) {
            //$('#text_content').html('');
            this.ready_text = this.textToP(this.rawTextToArray(this.raw_text), cls);
        },

        /* АНАГРАММЫ */
        makeAnagrammes() {
            let text = this.rawTextToArray(this.raw_text);
            text = _.map(text, (e) => {
                return _.join(this.shuffleAnagrammeString(e), ' ');
            });
            this.ready_text = this.textToP(text);
        },
        shuffleAnagrammeString(str) {
            // Проходимся по всем словам и если слово больше 3 символов, то перемешиваем буквы, кроме первой и последней. Не забываем про знаки препинания, которые могут встретиться в конце слова.
            //console.log(arr);
            return _.map(str.split(' '), (e) => {
                if (e.length > 3) {
                    let word = v.chars(e);
                    let punctuations = [];
                    let first = word.shift();
                    let last = '';
                    let i = 0;
                    //console.log(e);
                    while (i < 20) {
                        if (this.findPuncInEndOfArr(word)) {
                            punctuations.push(word.pop());
                        } else {
                            last = word.pop();
                            break;
                        }
                    }
                    //word = _.toString(_.shuffle(word));
                    word = _.shuffle(_.shuffle(word));
                    //console.log(first, word, last, punctuations);
                    return _.join(_.concat(first, word, last, punctuations), '');
                } else {
                    return e;
                }
            });
            //console.log(changedArray);
        },

        /* ПЕРЕМЕШАТЬ СЛОВА */
        letMixWords() {
            let str = this.rawTextToArray(this.raw_text);
            let paragraph = [];

            _.forEach(str, (item) => {
                let sentences = item.replace(/\.\s+/g, '.|').replace(/\?\s/g, '?|').replace(/\!\s/g, '!|').split("|");
                let p = [];
                _.forEach(sentences, (i) => {
                    let last_symbol = i.charAt(i.length - 1);
                    let words = i.substring(0, i.length - 1).split(' ');
                    let mix = _.shuffle(words);
                    p.push(mix.join(' ') + last_symbol);
                });
                paragraph.push(p);
            });

            this.ready_text = this.textToP(paragraph);

            /*
            let ret = [];

            this.ready_text = ret.join(' ');*/
        },

        /* Слова с конца */
        letReverseWords() {
            let text = this.rawTextToArray(this.raw_text);
            text = _.map(text, (e) => {
                return _.join(this.reverseWordString(e), ' ');
            });
            this.ready_text = this.textToP(text);
        },
        reverseWordString(str) {
            return _.map(str.split(' '), (e) => {
                if (e.length > 1) {
                    let word = v.chars(e);
                    let punctuations = [];
                    let i = 0;
                    while (i < 20) {
                        if (this.findPuncInEndOfArr(word)) {
                            punctuations.push(word.pop());
                        } else {
                            break;
                        }
                    }
                    word = _.reverse(word);
                    return _.join(_.concat(word, punctuations), '');
                } else {
                    return e;
                }
            });
        },

        /* Предложения с конца */
        letReverseSentence() {
            let str = this.rawTextToArray(this.raw_text);
            let paragraph = [];

            _.forEach(str, (item) => {
                let sentences = item.replace(/\.\s+/g, '.|').replace(/\?\s/g, '?|').replace(/\!\s/g, '!|').split("|");
                let p = [];
                _.forEach(sentences, (i) => {
                    let last_symbol = i.charAt(i.length - 1);
                    let words = i.substring(0, i.length - 1).split(' ');
                    let mix = _.reverse(words).join(' ');
                    //console.log(words, mix, last_symbol);
                    p.push(mix + last_symbol);
                });
                paragraph.push(p.join(' '));
            });

            //console.log(paragraph);

            this.ready_text = this.textToP(paragraph);
        },

        /* УДАЛЯЕМ ГЛАСНЫЕ */
        removeVowels() {
            let text = this.rawTextToArray(this.raw_text);
            let vovels = _.join(this.vovels_rus, '');
            let regExp = new RegExp('[' + vovels + ']', 'i');
            text = _.map(text, (e) => {
                return v.replace(e, new RegExp(regExp, 'g'), '');
            });
            this.ready_text = this.textToP(text);
        },

        /* ПРОПУСКАЕМ ГЛАСНЫЕ */
        skipVowels() {
            let text = this.rawTextToArray(this.raw_text);
            let vovels = _.join(this.vovels_rus, '');
            let regExp = new RegExp('[' + vovels + ']', 'i');
            text = _.map(text, (e) => {
                return v.replace(e, new RegExp(regExp, 'g'), '_');
            });
            this.ready_text = this.textToP(text);
        },

        /* ПРОПУСК БУКВ */
        skipWords() {
            //console.log('Skip words');
            let words = this.stringToWordsArray(this.raw_text);
            let params = this.modeParams.freq.value;
            //console.log(words, params);
            // Нам необходимо вычислить процент слов в зависимости от параметра
            // Вычислить процент букв в слове в зависимости от параметра
            // Сделать функцию которая выбирает случайные слова и случайные буквы в слове и заменяет их
            // Т.е. у нас 2 этапа - первый - это вычислить процент слов и получение случайных слов
            // Если в конце слова знак препинания, его не учитывать в замене слова
            // Проверить что букв в слове больше 2

            let q_words = words.length;
            let need_words_qnt = Math.ceil((q_words / 100) * params);
            let arr = [];
            for (let i = 0; i < words.length; i++) arr.push(i)
            let r_words = _.sampleSize(arr, need_words_qnt);
            //console.log(words);
            //console.log(r_words);
            _.forEach(r_words, (e) => {
                let current_word = words[e];
                let word_length = current_word.length;
                if (word_length > 2) {
                    let q_letters = Math.ceil(((word_length - 2) / 100) * params);
                    //console.log('Убрать количество букв в слове', current_word, q_letters);
                    let changed_word = this.changeRandomLettersInWord(current_word, q_letters);
                    // console.log(words[e], changed_word);
                    words[e] = changed_word;
                }
            });
            this.ready_text = this.textToP(this.rawTextToArray(words.join(' ')));

        },
        changeRandomLettersInWord(word, letters) {
            word = v.chars(word);
            let punctuations = [];
            let first = word.shift();
            let last = '';
            let i = 0;
            while (i < 20) {
                if (this.findPuncInEndOfArr(word)) {
                    punctuations.push(word.pop());
                } else {
                    last = word.pop();
                    break;
                }
            }

            let arr = [];
            for (let i = 0; i < word.length; i++) arr.push(i);
            let cutted_letters = _.sampleSize(arr, letters);
            //console.log(cutted_letters);
            _.forEach(cutted_letters, (e) => {
                word[e] = '_';
            });


            //console.log(first, word, last, punctuations);
            return _.join(_.concat(first, word, last, punctuations), '');
        },

        /* ЗАЧЕРКНУТЫЙ ТЕКСТ */
        makeCrossedText() {
            this.ready_text = this.textToP(this.rawTextToArray(this.raw_text), 'strike');
        },

        /* СЛУЧАЙНЫЙ РЕГИСТР */
        makeRandomCase() {
            let text = this.rawTextToArray(this.raw_text);
            this.ready_text = this.textToP(_.map(text, (e) => {
                let chars = v.chars(e);
                let ready = _.map(chars, (c) => {
                    return this.randomInteger(0, 1) ? c.toUpperCase() : c.toLowerCase();
                });
                return _.join(ready, '');
            }));
        },

        /* БЕЗ ПРОБЕЛОВ */
        makeWithoutSpaces() {
            let text = this.rawTextToArray(this.raw_text);
            this.ready_text = this.textToP(_.map(text, (e) => {
                //return v.replaceAll(e, /[ ]/, '');
                return v.replace(e, new RegExp(/[ ]/, 'g'), '');
            }), 'wrap');
        },

        /* Транслит */
        translitOneWord(word) {
            let A = {};
            let result = '';

            A["Ё"] = "YO";
            A["Й"] = "I";
            A["Ц"] = "TS";
            A["У"] = "U";
            A["К"] = "K";
            A["Е"] = "E";
            A["Н"] = "N";
            A["Г"] = "G";
            A["Ш"] = "SH";
            A["Щ"] = "SCH";
            A["З"] = "Z";
            A["Х"] = "H";
            A["Ъ"] = "'";
            A["ё"] = "yo";
            A["й"] = "i";
            A["ц"] = "ts";
            A["у"] = "u";
            A["к"] = "k";
            A["е"] = "e";
            A["н"] = "n";
            A["г"] = "g";
            A["ш"] = "sh";
            A["щ"] = "sch";
            A["з"] = "z";
            A["х"] = "h";
            A["ъ"] = "'";
            A["Ф"] = "F";
            A["Ы"] = "I";
            A["В"] = "V";
            A["А"] = "A";
            A["П"] = "P";
            A["Р"] = "R";
            A["О"] = "O";
            A["Л"] = "L";
            A["Д"] = "D";
            A["Ж"] = "ZH";
            A["Э"] = "E";
            A["ф"] = "f";
            A["ы"] = "i";
            A["в"] = "v";
            A["а"] = "a";
            A["п"] = "p";
            A["р"] = "r";
            A["о"] = "o";
            A["л"] = "l";
            A["д"] = "d";
            A["ж"] = "zh";
            A["э"] = "e";
            A["Я"] = "YA";
            A["Ч"] = "CH";
            A["С"] = "S";
            A["М"] = "M";
            A["И"] = "I";
            A["Т"] = "T";
            A["Ь"] = "'";
            A["Б"] = "B";
            A["Ю"] = "YU";
            A["я"] = "ya";
            A["ч"] = "ch";
            A["с"] = "s";
            A["м"] = "m";
            A["и"] = "i";
            A["т"] = "t";
            A["ь"] = "'";
            A["б"] = "b";
            A["ю"] = "yu";

            for (let i = 0; i < word.length; i++) {
                var c = word.charAt(i);

                result += A[c] || c;
            }

            return result;
        },
        translitText() {
            let text = this.rawTextToArray(this.translitOneWord(this.raw_text));
            this.ready_text = this.textToP(text);
        },

        /* Кодировка */
        codeText() {
            let upper = this.raw_text.toUpperCase();
            let text = this.rawTextToArray(this.codeString(upper));
            this.ready_text = this.textToP(text);
        },
        codeString(str) {
            let A = {};
            let result = '';

            A["А"] = "4";
            A["Б"] = "6";
            A["В"] = "8";
            A["Д"] = "9";
            A["Е"] = "3";
            A["И"] = "N";
            A["О"] = "0";
            A["Т"] = "7";
            A["У"] = "Y";
            A["Ш"] = "W";
            A["Я"] = "R";

            for (let i = 0; i < str.length; i++) {
                var c = str.charAt(i);

                result += A[c] || c;
            }

            return result;
        },

        /* Перевернутый */
        rotateText() {
            this.ready_text = '<div class="rotate">' + this.textToP(this.rawTextToArray(this.raw_text)) + '</div>';
        },

        /* Замена букв */
        changeLetters() {
            //console.log('change letters');
            let params = this.modeParams.changes;
            let text = this.rawTextToArray(this.raw_text);
            if (params.values.length > 0) {
                text = _.map(text, (e) => {
                    _.forEach(params.values, (p) => {
                        e = v.replace(e, new RegExp(p.letter, 'g'), p.change);
                    });
                    return e;
                });
            }
            this.ready_text = this.textToP(text);
        },

        /* Случайные пробелы */
        makeRandSpaces() {
            let paragraph = this.rawTextToArray(this.raw_text);
            let arr = [];
            _.forEach(paragraph, (p) => {
                let words = this.stringToWordsArray(p);
                let qnt = words.length - 1;
                let str = words.join('').split('');
                let l_arr = [];
                for (let i = 2; i < (str.length - 1); i++) l_arr.push(i);

                let positions = _.sampleSize(l_arr, qnt);

                _.forEach(positions, (e) => {
                    str.splice(e, 0, " ");
                });

                arr.push(str.join(''));
                //console.log(qnt, str, l_arr, positions);
            })
            this.ready_text = this.textToP(arr);
        },

        /* Шторка */
        async makeCurtain() {
            this.letStart();
            //this.active = true;
            //this.reading = true;
            console.log('make curtain');
            $('.curtains').empty();
            await this.makeNormalText('crt');
            let el = document.getElementById('text_content');
            let lh = this.getCurrentStyleParam('line-height');
            let height = el.offsetHeight + 1;
            let qnt = Math.round(height / lh);
            let q_h = height / qnt;
            let params = this.modeParams;
            let currentThis = this
            let currentParams = params
            let changes = true

            async function redrawingCurtain(currentThis, currentParams) {
                lh = currentThis.getCurrentStyleParam('line-height')
                height = el.offsetHeight + 1;
                qnt = Math.round(height / lh);
                q_h = height / qnt;

                function deleteCurtain(currentParams) {
                    document.querySelectorAll('.text_content.texts__content')[0].removeChild(document.querySelectorAll('.curtains')[0])
                    addCurtain(currentParams)
                }

                function addCurtain(currentParams) {
                    $('.text_content').append(`<div class="curtains"></div>`)
                    for (let i = 0; i <= qnt; i++) {
                        $('.curtains').append(`<div class="curtain" style="height: ${q_h}px;"><div class="curtain__block" style="height: ${currentParams.height.value}%; top: ${currentParams.offset.value}%"></div></div>`)
                    }
                }
                await deleteCurtain(currentParams)
            }
            let element = document.querySelectorAll('.text_content.texts__content')[0]
            new ResizeSensor(element, function() {
                if (!changes) {
                    redrawingCurtain(currentThis, currentParams)
                }
                changes = false
            });
            $('.text_content').append(`<div class="curtains"></div>`);
            for (let i = 1; i <= qnt; i++) {
                $('.curtains').append(`<div class="curtain" style="height: ${q_h}px;"><div class="curtain__block" style="height: ${params.height.value}%; top: ${params.offset.value}%"></div></div>`);
            }

            $(document).on('input', 'input[type="range"][name="height"]', (i) => {
                $('.curtain__block').css('height', i.target.value + '%');
            });
            $(document).on('input', 'input[type="range"][name="offset"]', (i) => {
                $('.curtain__block').css('top', i.target.value + '%');
            });
        },

        /* Исчезающий текст */
        async disappearing_text() {
            //this.reading = false;
            this.disappearingStarted = true
            let str = this.rawTextToArray(this.raw_text);
            let arr = [];
            _.forEach(str, (e) => {
                arr.push(this.breakTextBySpan(e, 'vis'));

            });
            await this.setText(arr);
            await this.startDisapear();
        },
        setText(arr) {
            this.ready_text = this.textToP(arr, 'readtest__text');
        },
        breakTextBySpan(text, cls) {
            let arr = text.split(' ');
            let txt = _.map(_.compact(arr), function(e) {
                return `<span class="${cls}">${e}</span>`;
            });
            return txt.join('');
        },
        async startDisapear() {
            let timer;
            let app = this;
            //let elements = document.getElementsByClassName('vis');
            let elements = $('.vis');
            let qnt = elements.length;
            this.disappearing_speed = this.modeParams.speed.value * 1000;
            //console.log(elements, qnt, Array.from(elements));

            $('input[type="range"][name="speed"]').on('input', (i) => {
                //console.log('change speed');
                this.disappearing_speed = i.target.value * 1000;
            });

            function reading(steps = 0) {
                //console.log('reading', steps, qnt);
                if (steps >= qnt || !app.params.start) {
                    console.log('finish');
                    app.params.finish = true;
                    app.reading = false;
                    return;
                } else {
                    //console.log('timeout');
                    if (app.reading) {
                        //let word = app.words[currentWord];
                        //app.currentWord = app.prepareWord(word);
                        $(elements[steps]).addClass('invisible');
                        steps++;
                        //console.log('Step', steps);
                    }
                    timer = setTimeout(reading, app.disappearing_speed, steps);
                }
            }

            reading();
        },

        /* Замена букв */
    },
    async mounted() {
        await this.checkHasText();
        this.reading = false;
        this.params.finish = false;
        this.params.start = true;
        this.raw_text = this.params.text.desc;
        this.makeNormalText();
        this.makeTransform();
        //this.texts_test();
        //this.makeAnagrammes();
    }
};